import scrollLock from 'scroll-lock';
import SimpleBar from 'simplebar';
import Splitting from 'splitting';

window.scrollLock = scrollLock;
window.SimpleBar = SimpleBar;
window.Splitting = Splitting;
